<script setup>
  import { defineProps, defineEmits } from "vue";
  const emit = defineEmits(["click"]);
  const props = defineProps({
    title: {
      type: String,
      default: "Enter Your title",
    },
    button: {
      type: String,
    },
  });

  const handleClick = () => {
    emit("click");
  };
</script>

<template>
  <div class="page-title">
    <h1>{{ title }}</h1>
    <el-button v-if="button" type="primary" @click="handleClick"
      >{{ button }}
    </el-button>
  </div>
</template>

<style lang="scss" scoped>
  .page-title {
    padding: 10px 0;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    h1 {
      font-size: 1.4rem;
      line-height: 36px;
      color: #606266;
      font-weight: bold;
      margin-right: 20px;
    }
  }
</style>
